const dictionary = {

    homepage : {
        homepage: '003_00_00_Homepage',
        realtime_instruments: '003_00_01_S_M_Rt',
        germany_instruments: '003_00_01_S_M_De',
        europe_instruments: '003_00_01_S_M_Eu',
        america_instruments: '003_00_01_S_M_Am',
        asia_instruments: '003_00_01_S_M_As',
        commodity_instruments: '003_00_01_S_M_Ro',
        currency_instruments: '003_00_01_S_M_Dev',
        aktioner_instruments: '003_00_01_S_M_Akt',
        search_result_Drop_Down: '003_01_02_L_TI_SuEr',
        host_adv_slider: "003_00_06_S_Divers",
        statistic_modal: "003_00_08_L_User_handeln",
        news_slider: "003_09_03_S_RN",
        news_modal: "003_09_01_L_News",
        video_modal: '003_09_04_L_Videos',
        analysen_modal: "003_10_01_L_Analyse",
        search_input_layer: "003_15_00_WPSucheErg",
        more_videos_modal_open: "003_00_07_L_Videos_weitere",
        layer_aktien_analysen_index: "003_01_05_L_AA",

        // tops flops
        tp_tecDax: "003_00_04_ToFl_TecDax",
        tp_dax: "003_00_04_ToFl_Dax",
        tp_sdax: "003_00_04_ToFl_SDax",
        tp_mdax: "003_00_04_ToFl_MDAX",
        tp_atx: "003_00_04_ToFl_ATX",
        tp_euro_stoxx: "003_00_04_ToFl_ESTOXX50",
        tp_dow_jones: "003_00_04_ToFl_DJ30",
        tp_nasdaq: "003_00_04_ToFl_Nasdaq100",
        tp_nikkie: "003_00_04_ToFl_Nikkei225",
        tp_hang_sang: "003_00_04_ToFl_HangSeng",
        tp_scale_all: "003_00_04_ToFl_ScaleAll",
        ALLE: '003_00_02_TI',
        AKTIEN: '003_00_02_TI_AK',
        FONDS: '003_00_02_TI_FO',
        ETF: '003_00_02_TI_ETF',
        ANLEIHEN: '003_00_02_TI_AN',
        load_more_news: '003_00_03_News_mehr',
        show_all_news: '003_09_00_News',
        layer_changelog: "003_16_05",
        search_layer: "003_15_00_WPSuche",
        search_result: "003_01_02_L_TI_SuEr",
        trading_slider:"003_00_02_S_TI",
        buy_stock: "003_12_02_L_WPK",
        add_to_watchlist: "003_13_02_L_WPH",
        zinsen_future_products:"003_00_01_S_M_ZiFu",
        load_more_analysen: "003_00_05_Analysen_mehr",
    },

    aktienuberblick: {
        aktienpage : '003_01_00_Aktien',

        most_searched_by_share: '003_01_03_S_AU_MGes',
        hot_instruments_by_trades: '003_01_03_S_AU_MGeh',
        layer_aktien_hot_werte: '003_01_03_L_AktienHot',
        layer_aktien_analysen_index: '003_01_05_L_AA',

        layer_thescreener_alle_upgrades: '003_01_06_L_tSCR_Up',
        layer_thescreener_alle_downgrades: '003_01_06_L_tSCR_Do',

        bsa_tecDax: "003_01_07_S_BSA_TecDax",
        bsa_dax: "003_01_07_S_BSA_Dax",
        bsa_sdax: "003_01_07_S_BSA_SDax",
        bsa_mdax: "003_01_07_S_BSA_MDAX",
        bsa_atx: "003_01_07_S_BSA_ATX",
        bsa_euro_stoxx: "003_01_07_S_BSA_ESTOXX50",
        bsa_dow_jones: "003_01_07_S_BSA_DJ30",
        bsa_nasdaq: "003_01_07_S_BSA_Nasdaq100",
        bsa_nikkie: "003_01_07_S_BSA_Nikkei225",
        bsa_hang_sang: "003_01_07_S_BSA_HangSeng",
        bsa_scale_all: "003_01_07_S_BSA_ScaleAll",

        load_more_news: '003_01_09_News_mehr',
        show_all_news: '003_09_01_L_News',
        tops_and_flops: '003_01_08_ToFl_',

        tp_tecDax: "003_00_04_ToFl_TecDax",
        tp_dax: "003_00_04_ToFl_Dax",
        tp_sdax: "003_00_04_ToFl_SDax",
        tp_mdax: "003_00_04_ToFl_MDAX",
        tp_atx: "003_00_04_ToFl_ATX",
        tp_euro_stoxx: "003_00_04_ToFl_ESTOXX50",
        tp_dow_jones: "003_00_04_ToFl_DJ30",
        tp_nasdaq: "003_00_04_ToFl_Nasdaq100",
        tp_nikkie: "003_00_04_ToFl_Nikkei225",
        tp_hang_sang: "003_00_04_ToFl_HangSeng",
        tp_scale_all: "003_00_04_ToFl_ScaleAll",

        search_result: '003_02_02_L_SuEr',
        stock_analysis_slider: "003_01_05_S_AA",
        stock_analysis_index: "003_01_05_L_AA",
        analysen_modal: "003_10_01_L_Analyse",
        stock_screener_rating: "003_01_06_S_tSCR",
        // best_and_worse: "003_01_07_S_BSA",
        tops_and_flops_share: "003_01_08_ToFl",
        news_modal: "003_09_01_L_News",
        buy_stock: "003_12_02_L_WPK",
        add_to_watchlist: "003_13_02_L_WPH",
        search_result_Drop_Down: "003_01_02_L_TI_SuEr",
        search_input_layer: "003_15_00_WPSucheErg",
        analysenKursziele: '003_01_01_L_AN_KuZ',
        bilanz : "003_01_01_L_B",
        guvCashflow : "003_01_01_L_GuV",
        

    },


    sharessearch: {
        share_search_page: "003_01_02_AS_FK",
        fundamentale_kennzahlen: '003_01_02_AS_FK',
        search_result: "003_01_02_L_SuEr",
        tabs: '003_01_02_AS_FK',
        buy_stock: "003_12_02_L_WPK",
        add_to_watchlist: "003_13_02_L_WPH",
        search_result_Drop_Down: "003_01_02_L_TI_SuEr",
        search_input_layer: "003_15_00_WPSucheErg",

    },

    shareportrait: {
        new_limit: "003_14_02_L_LA",
        add_to_watchlist:"003_13_02_L_WPH",
        portrait_page: "003_01_01_AktienEW",
        borsenplatze: '003_01_01_S_BP',
        watchlist: "003_13_02_L_WPH",
        portfolios: "003_12_02_L_WPK",
        weitere_borsenplatze: '003_01_01_L_BP',
        buy_stock: "003_12_02_L_WPK",
        times_sales: '003_01_01_L_TS',
        historische_kurse: '003_01_01_L_HI',
        kursvergleich: '003_01_01_L_KV',
        guvCashflow: '003_01_01_L_GuV',
        technischeKennzahlen: '003_01_01_L_TK',
        theScreenerRating: '003_01_01_L_tSCR',
        fundamentaleKennzahlen: '003_01_01_L_FK',
        analysenKursziele: '003_01_01_L_AN_KuZ',
        unternehmensprofil: '003_01_01_L_UP',
        bilanz: '003_01_01_L_BI',
        load_more_news: '003_01_01_News_mehr',
        show_all_news: '003_09_01_L_News',
        monteCarlo: '003_01_01_MCeK',
        news_modal: "003_09_01_L_News",
        limits:'003_14_03_L_LU_EW',
        search_input_layer: "003_15_00_WPSucheErg",
        chart_analyse:"003_01_01_L_Chart",
        chart_comparison:"003_01_01_L_Chart"
    },

    charttool: {
        line_chart: "003_01_01_L_Chart",
        candlestick_chart: "003_01_01_L_Chart",
        ohlc_chart: "003_01_01_L_Chart",
        intraday: "003_01_01_L_Chart",
        one_week: "003_01_01_L_Chart",
        one_month: "003_01_01_L_Chart",
        three_month: "003_01_01_L_Chart",
        six_month: "003_01_01_L_Chart",
        one_year: "003_01_01_L_Chart",
        three_year: "003_01_01_L_Chart",
        five_year: "003_01_01_L_Chart",
        ten_year: "003_01_01_L_Chart",
        indicator_in_chart: "003_01_01_L_Chart",
        indicator_under_chart: "003_01_01_L_Chart",
        gd_20: "003_01_01_L_Chart",
        gd_50: "003_01_01_L_Chart",
        gd_100: "003_01_01_L_Chart",
        gd_200: "003_01_01_L_Chart",
        annotation_tool: "003_01_01_L_Chart",
        select_for_compare: "003_01_01_L_Chart",
        remove_from_comparison: "003_01_01_L_Chart",
        remove_all_comparison: "003_01_01_L_Chart",
        chart_analyse:"003_01_01_L_Chart",

    },

    multiMarketPortrait: {
        portrait_page: "003_01_01_MMREW",
        search_input_layer: "003_15_00_WPSucheErg",
    },

    fondsPortrait: {
        uberblick: '003_02_00_Fonds',
        portrait_page: '003_02_01_FondsEW',
        suche: '003_02_02_Fonds_Suche',
        slider: '003_02_01_S_BP',
        watchlist: "003_13_02_L_WPH",
        add_to_watchlist: "003_13_02_L_WPH",
        weitere_borsenplatze: '003_02_01_L_BP',
        times_sales: '003_02_01_L_TS',
        historische_kurse: '003_02_01_L_HI',
        kursvergleich: '003_02_01_L_KV',
        asset_allocation: '003_02_01_AsAllo',
        borsenplatze: "003_02_01_L_BP",
        asset_allocation_slider: "003_02_01_AsAllo",
        create_limit_banner: "003_14_02_L_LA",
        buy_stock: "003_12_02_L_WPK",
        portfolios: "003_12_02_L_WPK",
        new_limit: "003_14_02_L_LA",

        fondstart: '003_02_02_FS_Art',
        thema: '003_02_02_FS_Thema',
        regionen: '003_02_02_FS_Reg',
        strategy: '003_02_02_FS_Stra',
        waehrung: '003_02_02_FS_Wae',
        search_input_layer: "003_15_00_WPSucheErg",

        chart_analyse:"003_01_01_L_Chart",
        chart_comparison:"003_01_01_L_Chart"
    },

    fonds_search: {
        funds_search_page: "003_02_02_Fonds_Suche",
        tabs: "003_02_02_Fonds_Suche",
        search_result: "003_02_02_L_SuEr",
        buy_stock: "003_12_02_L_WPK",
        add_to_watchlist: "003_13_02_L_WPH",
        search_result_Drop_Down: "003_02_02_L_SuEr",
        fondstart: "003_02_02_Fonds_Suche",
        thema: "003_02_02_Fonds_Suche" ,
        regionen: "003_02_02_Fonds_Suche" ,
        strategy: "003_02_02_Fonds_Suche" ,
        waehrungs: "003_02_02_Fonds_Suche",
        search_input_layer: "003_15_00_WPSucheErg",
        new_limit: "003_14_02_L_LA",
    },

    derivatives: {
        uberblick: '003_05_00_Derivate',
        slider: '003_05_03_S_Der_Mges',
        meistgesucht: '003_05_03_S_Der_Mges',
        meistgehandelt: '003_05_03_S_Der_Mgeh',

        basiswertauswahl: '003_05_04_BWA_',
        basiswertauswahl_topDax: '003_05_04_BWA_TDAX',
        basiswertauswahl_flopDax: '003_05_04_BWA_FDAX',
        basiswertauswahl_Meistgesucht: '003_05_04_BWA_MGes',
        basiswertauswahl_Meistgehandelt: '003_05_04_BWA_Mgeh',
        basiswertauswahl_Eigener_Basiswert: '003_05_02_L_Derivate_Suche_BW',

        anlageprodukte: '003_05_06_S_APTop5',

        search: '003_05_02_Derivate_Suche',
        search_Basiswert: '003_05_02_Derivate_Suche_Basis',
        search_Derivateart: '003_05_02_Derivate_Suche_Art',
        search_basiswert_change: '003_05_02_L_Derivate_Suche_BW',
        search_result: '003_05_02_Derivate_Suchergebnis',
        search_dropdown: '003_05_02_Derivate_Suche',
        underlying_tags: '003_05_02_Derivate_Suche',
        underlying_search_input: '003_05_02_L_Derivate_Basiswertsuche',
        underlying_tags_select: '003_05_02_Derivate_Suchergebnis',
        search_input_layer: "003_15_00_WPSucheErg",
    },

    zertificate_portrait : {
        add_to_watchlist: "003_13_02_L_WPH",
        buy_stock:"003_12_02_L_WPK",
        new_limit: "003_14_02_L_LA",
        portrait: '003_05_01_Z_EW',
        save_limit: '003_14_03_L_LU_EW',
        portfolios: '003_12_02_L_WPK',
        watchlist: '003_13_02_L_WPH',
        slider: '003_05_01_Z_S_BP',
        weitere_borsenplatze: '003_05_01_Z_L_BP',
        times_sales: '003_05_01_Z_L_TS',
        historische_kurse: '003_05_01_Z_L_HI',
        search_input_layer: "003_15_00_WPSucheErg",

    },

    optionsschein_portrait: {
        add_to_watchlist: "003_13_02_L_WPH",
        buy_stock:"003_12_02_L_WPK",
        new_limit: "003_14_02_L_LA",
        portrait: '003_05_01_O_EW',
        save_limit: '003_14_03_L_LU_EW',
        portfolios: '003_12_02_L_WPK',
        watchlist: '003_13_02_L_WPH',

        slider: '003_05_01_O_S_BP',
        weitere_borsenplatze: '003_05_01_O_L_BP',
        times_sales: '003_05_01_O_L_TS',
        historische_kurse: '003_05_01_O_L_HI',
        search_input_layer: "003_15_00_WPSucheErg",

    },

    knockout_portrait: {
        add_to_watchlist: "003_13_02_L_WPH",
        buy_stock:"003_12_02_L_WPK",
        new_limit: "003_14_02_L_LA",
        portrait: '003_05_01_K_EW',
        save_limit: '003_14_03_L_LU_EW',
        portfolios: '003_12_02_L_WPK',
        watchlist: '003_13_02_L_WPH',

        slider: '003_05_01_K_S_BP',
        weitere_borsenplatze: '003_05_01_K_L_BP',
        times_sales: '003_05_01_K_L_TS',
        historische_kurse: '003_05_01_K_L_HI',
        search_input_layer: "003_15_00_WPSucheErg",

    },


    indexoverview: {
        overview_page: "003_06_00_Indizes",
        // tops flops
        tp_tecDax: "003_00_04_ToFl_TecDax",
        tp_dax: "003_00_04_ToFl_Dax",
        tp_sdax: "003_00_04_ToFl_SDax",
        tp_mdax: "003_00_04_ToFl_MDAX",
        tp_atx: "003_00_04_ToFl_ATX",
        tp_euro_stoxx: "003_00_04_ToFl_ESTOXX50",
        tp_dow_jones: "003_00_04_ToFl_DJ30",
        tp_nasdaq: "003_00_04_ToFl_Nasdaq100",
        tp_nikkie: "003_00_04_ToFl_Nikkei225",
        tp_hang_sang: "003_00_04_ToFl_HangSeng",
        tp_scale_all: "003_00_04_ToFl_ScaleAll",
        search_input_layer: "003_15_00_WPSucheErg",

        find_index: "003_06_02_Indizes_Suche",
        find_index_layer: "003_06_02_L_Indizes_finden",
        realtime_instruments: '003_06_05_S_IU_RT',
        germany_instruments: '003_06_05_S_IU_DE',
        europe_instruments: '003_06_05_S_IU_EU',
        america_instruments: '003_06_05_S_IU_AM',
        asia_instruments: '003_06_05_S_IU_AS',
        crypto_instruments: '003_06_05_S_IU_Krypto',
        aktioner_instruments: '003_06_05_S_IU_Akt',
        // Find Index Region dropdown
        Alle: "003_06_02_Indizes_Suche",
        Deutsche: "003_06_02_IS_Region_DE",
        Europäische: "003_06_02_IS_Region_EU",
        Asiatische: "003_06_02_IS_Region_AS",
        US: "003_06_02_IS_Region_AM",
        Branchen: "003_06_02_IS_Branchen",
        // Tops and Flops
        bsa: "003_06_04_S_BSA",
        load_more_news: "003_06_06_News_mehr",
        tops_and_flops: "003_06_03_TF_",
        market_reports: "003_06_06_News_mehr",
        buy_stock: "003_12_02_L_WPK",
        add_to_watchlist: "003_13_02_L_WPH",
        industries_filter: "003_06_02_IS_Branchen",
        bsa_tecDax: "003_01_07_S_BSA_TecDax",
        bsa_dax: "003_01_07_S_BSA_Dax",
        bsa_sdax: "003_01_07_S_BSA_SDax",
        bsa_mdax: "003_01_07_S_BSA_MDAX",
        bsa_atx: "003_01_07_S_BSA_ATX",
        bsa_euro_stoxx: "003_01_07_S_BSA_ESTOXX50",
        bsa_dow_jones: "003_01_07_S_BSA_DJ30",
        bsa_nasdaq: "003_01_07_S_BSA_Nasdaq100",
        bsa_nikkie: "003_01_07_S_BSA_Nikkei225",
        bsa_hang_sang: "003_01_07_S_BSA_HangSeng",
        bsa_scale_all: "003_01_07_S_BSA_ScaleAll",
        news_modal: "003_09_01_L_News",
        stock_analysis_slider:"003_06_07_S_AA",
        stock_analysis_index:"003_06_07_L_AA",
        default:"003_18_05_Def"
    },

    indexPortrait : {
        news_modal: "003_09_01_L_News",
        analysen_modal:"003_10_01_L_Analyse",
        new_limit: "003_14_02_L_LA",
        add_to_watchlist:"003_13_02_L_WPH",
        portrait_page: "003_06_01_IndizesEW",
        borsenplatze: "003_06_01_S_BP",
        slider: "003_06_01_S_BP",
        save_limit:  "003_14_03_L_LU_EW",
        // limits: "003_14_03_L_LU_EW",
        portfolios: "003_12_02_L_WPK",
        watchlist: "003_13_02_L_WPH",
        buy_stock: "003_12_02_L_WPK",
        weitere_borsenplatze: "003_06_01_L_BP",
        times_sales: '003_06_01_L_TS',
        historische_kurse: '003_06_01_L_HI',
        kursvergleich: "003_06_01_L_KV",
        monteCarlo: "003_06_01_MCeK",
        layer_thescreener_alle: '003_06_01_L_tSCR',
        index_composition: "003_06_01_Zus",
        Alle: "003_06_01_Zus_Sort",
        Tops: "003_06_01_Zus_Sort_TF",
        Volumen: "003_06_01_Zus_Sort_Vo",
        Umsatz: "003_06_01_Zus_Sort_Um",
        Trades: "003_06_01_Zus_Sort_TR",
        load_more_news: "003_06_01_News_mehr",
        load_more_analysen: "003_06_01_Analysen_mehr",
        search_input_layer: "003_15_00_WPSucheErg",
        chart_analyse:"003_01_01_L_Chart",
        chart_comparison:"003_01_01_L_Chart"
    },
    bondsPortrait: {
        weitere_borsenplatze: "003_04_01_L_BP" ,
        add_to_watchlist: "003_13_02_L_WPH",
        watchlist: "003_13_02_L_WPH",
        portfolios: "003_12_02_L_WPK",
        portrait_page : "003_04_01_AnleihenEW",
        borsenplatze: "003_04_01_L_BP",
        slider: "003_04_01_S_BP",
        times_sales: '003_04_01_L_TS',
        historische_kurse: '003_04_01_L_HI',
        create_limit_banner: "003_14_02_L_LA",
        buy_stock: "003_12_02_L_WPK",
        search_input_layer: "003_15_00_WPSucheErg",
        new_limit:"003_14_02_L_LA",
        chart_analyse:"003_01_01_L_Chart",
        chart_comparison:"003_01_01_L_Chart"
    },
    bondsSearch: {
        bonds_search_page: "003_04_02_Anleihen_Suche",
        currency: "003_04_02_AnS_Wae",
        issuer: "003_04_02_AnS_Iss",
        type: "003_04_02_AnS_Art",
        search_result: "003_04_02_L_SuEr",
        tabs: "003_04_02_AnS",
        buy_stock: "003_12_02_L_WPK",
        add_to_watchlist: "003_13_02_L_WPH",
        search_result_Drop_Down:'003_04_02_L_SuEr',
        search_input_layer: "003_15_00_WPSucheErg",
    },
    news: {
        news_page: "003_09_00_News",
        news_modal: "003_09_01_L_News",
        news_search: "003_09_02_News_Suche",
        news_slider: "003_09_03_S_RN",
        more_videos_modal: "003_09_04_L_Videos",
        video_modal: "003_09_04_L_Videos",
        search_input_layer: "003_15_00_WPSucheErg",
    },
    analysen: {
        analysen_page: "003_10_00_Analysen",
        positive: "003_01_01_L_AN_KuZ",
        neutral: "003_01_01_L_AN_KuZ",
        negative: "003_01_01_L_AN_KuZ",
        six_months: "003_01_01_L_AN_KuZ",
        twelve_months: "003_01_01_L_AN_KuZ",
        analyses_with_updates: "003_01_01_L_AN_KuZ",
        analysen_modal: "003_10_01_L_Analyse",
        analyses_search: "003_10_02_Analysen_Suche",
        search_input_layer: "003_15_00_WPSucheErg",
        analysenKursziele:"003_01_01_L_AN_KuZ"


    },
    etfSearch: {
        etf_search_page: "003_03_02_ETF_Suche",
        strategy: "003_03_02_ETFS_Stra",
        region: "003_03_02_ETFS_Reg",
        sector: "003_03_02_ETFS_Sec",
        type: "003_03_02_ETFS_Art",
        tabs: "003_03_02_ETFS_ART",
        buy_stock: '003_12_02_L_WPK',
        add_to_watchlist: '003_13_02_L_WPH',
        search_result: '003_03_02_L_SuEr',
        search_result_Drop_Down: "003_03_02_L_SuEr",
        search_input_layer: "003_15_00_WPSucheErg",
    },
    etfPortrait: {
        weitere_borsenplatze: "003_03_01_L_BP",
        portrait_page: "003_03_01_ETFEW",
        borsenplatze: "003_03_01_L_BP",
        slider: "003_03_01_S_BP",
        buy_stock: "003_12_02_L_WPK",
        add_to_watchlist: '003_13_02_L_WPH',
        times_sales: '003_03_01_L_TS',
        historische_kurse: '003_03_01_L_HI',
        kursvergleich: "003_03_01_L_KV",
        search_input_layer: "003_15_00_WPSucheErg",
        chart_analyse:"003_01_01_L_Chart",
        chart_comparison:"003_01_01_L_Chart"

    },
    currencyOverview: {
        currency_overview_page: "003_07_00_Devisen",
        currency_instruments_eur: "003_07_05_S_DU_EUR",
        currency_instruments_usd: "003_07_05_S_DU_USD",
        currency_instruments_jpy: "003_07_05_S_DU_JPY",
        currency_instruments_gbp: "003_07_05_S_DU_GBP",
        currency_instruments_chf: "003_07_05_S_DU_CHF",
        performance_chart_section: "003_07_03_PerfV",
        currency_perf_chart_drop: "003_07_03_PerfV",
        realtime_crossrates: "003_07_04_Cross",
        Korellationen: "003_07_04_Korr",
        find_currency: "003_07_02_Devisen_Suche",
        find_currency_ALL: "003_07_02_Devisen_Suche_Alle",
        find_currency_EUR: "003_07_02_Devisen_Suche_EUR",
        find_currency_USD: "003_07_02_Devisen_Suche_USD",
        find_currency_JPY: "003_07_02_Devisen_Suche_JPY",
        find_currency_GBP: "003_07_02_Devisen_Suche_GBP",
        find_currency_CHF: "003_07_02_Devisen_Suche_CHF",
        find_currency_HKD: "003_07_02_Devisen_Suche_HKD",
        find_currency_CNY: "003_07_02_Devisen_Suche_CNY",
        find_currency_AUD: "003_07_02_Devisen_Suche_AUD",
        find_currency_CAD: "003_07_02_Devisen_Suche_CAD",
        find_currency_NZD: "003_07_02_Devisen_Suche_NZD",
        find_currency_DKK: "003_07_02_Devisen_Suche_DKK",
        find_currency_HUF: "003_07_02_Devisen_Suche_HUF",
        find_currency_TWD: "003_07_02_Devisen_Suche_TWD",
        find_currency_SGD: "003_07_02_Devisen_Suche_SGD",
        find_currency_SEK: "003_07_02_Devisen_Suche_SEK",
        find_currency_NOK: "003_07_02_Devisen_Suche_NOK",
        find_currency_KWD: "003_07_02_Devisen_Suche_KWD",
        find_currency_modal: "003_07_02_Devisen_Suche_EUR",
        load_more_news: "003_07_06_News_mehr",
        buy_stock: "003_12_02_L_WPK",
        add_to_watchlist: "003_13_02_L_WPH",
        corssrates: "003_07_04_Cross",
        search_input_layer: "003_15_00_WPSucheErg",
    },
    currencyPortrait: {
        add_to_watchlist: "003_13_02_L_WPH",
        news_modal: "003_09_01_L_News",
        buy_stock:"003_12_02_L_WPK",
        new_limit: "003_14_02_L_LA",
        portrait_page: "003_07_01_DevisenEW",
        borsenplatze: "003_07_01_S_BP",
        slider: "003_07_01_S_BP",
        save_limit:"003_14_03_L_LU_EW",
        // limits: "003_14_03_L_LU_EW",
        portfolios: "003_12_02_L_WPK",
        watchlist: "003_13_02_L_WPH",
        weitere_borsenplatze: "003_07_01_L_BP",
        times_sales: '003_07_01_L_TS',
        historische_kurse: '003_07_01_L_HI',
        kursvergleich: "003_07_01_L_KV",
        technischeKennzahlen: "003_07_01_L_TK",
        monteCarlo: "003_07_01_MCeK",
        load_more_news: "003_07_01_News_mehr",
        search_input_layer: "003_15_00_WPSucheErg",
        chart_analyse:"003_01_01_L_Chart",
        chart_comparison:"003_01_01_L_Chart"
    },
    commodityOverview : {
        news_modal: "003_09_01_L_News",
        commodity_overview_page: "003_08_00_Rohstoffe",
        realtime_commodities: "003_08_03_S_RU",
        agro_products: "003_08_03_S_AP",
        industrial_metals: "003_08_03_S_IM",
        precious_metals: "003_08_03_S_EM",
        energy: "003_08_03_S_EN",
        find_index_layer: "003_08_05_L_RI",
        load_more_news: "003_08_06_News_mehr",
        all_raw_materials: "003_08_04_L_RL",
        Branchen: "003_08_05_L_RI",
        buy_stock:"003_12_02_L_WPK",
        add_to_watchlist: "003_13_02_L_WPH",
        search_input_layer: "003_15_00_WPSucheErg",
    },
    commodityPortrait: {
        news_modal: "003_09_01_L_News",
        add_to_watchlist: "003_13_02_L_WPH",
        buy_stock:"003_12_02_L_WPK",
        new_limit: "003_14_02_L_LA",
        portrait_page: "003_08_01_RohstoffeEW",
        borsenplatze: "003_08_01_S_BP",
        slider: "003_08_01_S_BP",
        save_limit: "003_14_03_L_LU_EW",
        // limits: "003_14_03_L_LU_EW",
        portfolios: "003_12_02_L_WPK",
        watchlist: "003_13_02_L_WPH",
        weitere_borsenplatze: "003_08_01_L_BP",
        times_sales: '003_08_01_L_TS',
        historische_kurse: '003_08_01_L_HI',
        kursvergleich: "003_08_01_L_KV",
        technischeKennzahlen: "003_08_01_L_TK",
        monteCarlo: "003_08_01_MCeK",
        load_more_news: "003_08_01_News_mehr",
        find_index_layer: "003_08_05_L_RI",
        Branchen: "003_08_05_L_RI",
        search_input_layer: "003_15_00_WPSucheErg",
        chart_analyse:"003_01_01_L_Chart",
        chart_comparison:"003_01_01_L_Chart"
    },
    mein_finanztreff: {
        news_modal: "003_09_01_L_News",
        unauthenticated: "003_11_01_S_GU",
        mf_page: "003_11_00_Mein_Finanztreff",
        portfolios: "003_11_01_S_PF",
        limits: "003_11_01_S_Lim",
        watchlists: "003_11_01_S_WL",
        porfolio_settings: "003_11_03_L_PF_Ein",
        create_portfolio: "003_11_03_L_PF_Anl",
        watchlist_settings: "003_11_03_L_WL_Ein",
        create_watchlist: "003_11_03_L_WL_Anl",
        edit_limit: "003_14_01_L_LB",
        new_limit: "003_14_02_L_LA",
        import_portfolios: "003_11_03_L_PF_Imp",
        news_modal_mf:"003_13_03_L_WLN",
        limit_Sortierung:"003_14_04_Sort",
        watchlist_settings_modal:"003_13_01_L_WL_Ein",
        watchlist_page: "003_13_10_WL_Ueb",
        portfolio_nav: "003_12_10_PF_Ueb",
        search_input_layer: "003_15_00_WPSucheErg",
        single_portfolio:"003_11_00_Mein_Finanztreff",
        watchlist_slider:"003_11_00_Mein_Finanztreff",
        sort_limits:"003_14_04_Sort",
    },
    mf_portfolios: {
        portfolio_page: "003_12_00_PF",
        portfolio_banner_item_0: "003_12_01_S_PFU",
        portfolio_banner_item_1: "003_12_01_S_PF_AA",
        portfolio_banner_item_2: "003_12_01_S_PF_LT",
        portfolio_banner_item_3: "003_12_01_S_PF_Kon",
        buy_stock: "003_12_02_L_WPK",
        transaction_history: "003_12_03_L_Tra",
        account_modal: "003_12_04_L_Kon",
        deposit_modal: "003_12_06_L_Einz",
        withdraw_modal: "003_12_07_L_Ausz",
        news_modal_mf: "003_12_08_L_PFN",
        news_load_more_mf: "003_12_08_L_PFNm",
        new_limit: "003_14_02_L_LA",
        edit_single_value: "003_12_05_L_EWB",
        portfolio_alert_modal: "003_12_01_L_PF_Alert",
        portfolio_settings_modal: "003_12_01_L_PF_Ein",
        portfolio_tile_view: "003_12_09_S_KA",
        news_modal: "003_09_01_L_News",
        porfolio_settings: "003_12_01_L_PF_Ein",
        sorting: "003_14_04_Sort",
        search_input_layer: "003_15_00_WPSucheErg",
        single_portfolio:"003_12_10_PF_Ueb",
        sorting_apply:"003_12_10_PF_Sort",
        konto:"003_12_04_L_Kon",
        ertrage:"003_12_11_L_Er",
        portfolio_views:"003_12_00_PF",
        portfolio_analyze_layer:"003_12_11_L_PFA"

    },
    mf_watchlists: {
        watchlist_page: "003_13_00_WL",
        news_modal_mf: "003_13_03_L_WLNm",
        news_load_more_mf: "003_13_03_L_WLNm",
        edit_watchlist: "003_13_02_L_EWB",
        add_to_watchlist: "003_13_02_L_WPH",
        watchlist_banner_item_0: "003_13_01_S_WLU",
        watchlist_banner_item_1: "003_13_01_S_WL_AA",
        watchlist_settings_modal: "003_13_01_L_WL_Ein",
        new_limit: "003_14_02_L_LA",
        news_modal: "003_09_01_L_News",
        watchlist_tile_view: "003_13_04_S_KA",
        sorting: "003_13_10_WL_Sort",
        search_input_layer: "003_15_00_WPSucheErg",
        watchlist_slider:"003_13_10_WL_Ueb",
        single_watchlist:"003_13_00_WL",
        watchlist_banner_item:"003_13_01_S_WLU",

    },
    mf_limits: {
        limits_page: "003_14_00_Lim",
        edit_limit: "003_14_01_L_LB",
        new_limit: "003_14_02_L_LA",
        limits: "003_14_03_L_LU_EW",
        search_input_layer: "003_15_00_WPSucheErg",
        slider_limits:"003_14_00_S_LimU",
        sort_limits:"003_14_04_Sort",
        limit_Sortierung:"003_14_04_Sort"
    },
    Error_page:{
        Error: '003_17_01',
        search_input_layer: "003_15_00_WPSucheErg",
    },
    Footer:{
        Impressum: "003_18_01" ,
        Nutzungshinweise: "003_18_02",
        Datenschutz: "003_18_03",
        Cookierichtlinie: "003_18_04",
        search_input_layer: "003_15_00_WPSucheErg",
    },
    searchPage: {
        searchpage: '003_15_00_WPSucheErg',
        assets_tabs : '003_15_01',
        search_input_layer: "003_15_00_WPSucheErg",
        search:"003_15_01"
    },
    etc_portrait: {
        slider: "003_03_01_S_BP",
        watchlist: "003_13_02_L_WPH",
        portfolios: "003_12_02_L_WPK",
        new_limit: "003_14_02_L_LA",
    },
    termine:{
        termine_page:"003_19_01"
    }

}


export function triggerInfonlineAuto(value: string) {
    const section = guessInfonlineSection();
    trigInfonline(section, value);
}

export function trigInfonline(section: string, value: string) {
    const ivw = getInfonlineTag(section, value);

    // @ts-ignore
    window['infonlineCounter'](ivw);
}
export function trigInfonlineAction(value: string) {
    return () => trigInfonline(guessInfonlineSection(), value);
}

export function getInfonlineTag(section: string, value: string) {
    let ivw = value;
    // @ts-ignore
    const _section: any = dictionary[section];
    if(_section && _section[value]) {
        // @ts-ignore
        ivw = _section[value];
    }

    return ivw;
}

export function guessInfonlineSection() {
    // console.log(window.location.pathname);
    const currentPath = window.location.pathname;
    if(currentPath.startsWith('/suche')) return 'searchPage'
    if (currentPath.startsWith('/aktien/suche')) return 'sharessearch';
    if (currentPath.startsWith('/aktien/kurse/')) return 'shareportrait';
    if (currentPath.startsWith('/aktien/analysen/')) return 'analysen';
    if (currentPath.startsWith('/aktien/chart-analyse/')) return 'charttool';
    if (currentPath.startsWith('/aktien')) return 'aktienuberblick';
    if (currentPath.startsWith('/fonds/suche/')) return "fonds_search";
    if (currentPath.startsWith('/fonds/kurse/')) return 'fondsPortrait';
    if (currentPath.startsWith('/fonds/chart-analyse/')) return 'charttool';
    if (currentPath.startsWith('/zertifikate/kurse/')) return 'zertificate_portrait';
    if (currentPath.startsWith('/optionsschein/kurse/')) return 'optionsschein_portrait';
    if (currentPath.startsWith('/hebelprodukte/kurse/')) return 'knockout_portrait';
    if(currentPath.startsWith('/hebelprodukte/suche/')) return 'derivatives'
    if (currentPath.startsWith('/indizes/kurse/')) return "indexPortrait";
    if (currentPath.startsWith('/indizes/chart-analyse/')) return 'charttool';
    if (currentPath.startsWith('/indizes')) return 'indexoverview';
    if (currentPath.startsWith('/anleihen/suche')) return "bondsSearch";
    if (currentPath.startsWith('/anleihen/kurse/')) return "bondsPortrait";
    if (currentPath.startsWith("/nachrichten")) return "news";
    if (currentPath.startsWith('/analysen')) return "analysen";
    if (currentPath.startsWith('/etf/kurse/')) return "etfPortrait"
    if (currentPath.startsWith('/etf/suche')) return "etfSearch";
    if(currentPath.startsWith('/etc/kurse')) return "etc_portrait"
    if (currentPath.startsWith('/etf/chart-analyse/')) return 'charttool';
    if (currentPath.startsWith('/devisen/kurse/')) return "currencyPortrait"
    if (currentPath.startsWith('/devisen/chart-analyse/')) return 'charttool';
    if (currentPath.startsWith('/devisen')) return "currencyOverview";
    if (currentPath.startsWith('/rohstoffe/kurse/')) return "commodityPortrait";
    if (currentPath.startsWith('/rohstoffe/chart-analyse/')) return 'charttool';
    if (currentPath.startsWith('/rohstoffe')) return "commodityOverview";
    if (currentPath.startsWith('/mein-finanztreff/portfolios/')) return "mf_portfolios";
    if (currentPath.startsWith('/mein-finanztreff/portfolio/')) return  "mf_portfolios"
    if (currentPath.startsWith('/mein-finanztreff/watchlisten/')) return "mf_watchlists";
    if (currentPath.startsWith('/mein-finanztreff/watchlist/')) return "mf_watchlists";
    if (currentPath.startsWith('/mein-finanztreff/limits')) return "mf_limits";
    if (currentPath.startsWith('/mein-finanztreff/')) return "mein_finanztreff";
    if (currentPath.startsWith('/termine')) return "termine";

    return 'homepage';
}
